import { FILE_EXTENSION } from "@ea/shared_types/next/ea.consts";

export async function downloadFileBlob(file: Blob, name: string) {
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(file);
  link.download = name;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
}

export const sanitizeScriptNameToFilename = (name: string) => name.replace(/[^a-z0-9]/gi, "_");

export const generateDatasourceTemplateName = ({
  id,
  name = "script",
}: {
  id: number;
  name?: string;
}) => `[${id}]-${sanitizeScriptNameToFilename(name)}${FILE_EXTENSION.XLSX}`;
